import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-use';
import { PageHitCountApi } from '../../../shared/Helper';
import BannerImg from '../../../../public/assets/images/BannersFiles/27.jpg';
import StaticBanner from '../../../components/elements/StaticBanner';
import Ourpolicy from './Ourpolicy';

const OurPolicyPdfView = () => {
  const [viewPrivacyPolicy, setViewPrivacyPolicy] = useState(false);
  const { pathname } = useLocation();
   const { t } = useTranslation();


  useEffect(() => {
    PageHitCountApi(pathname, 0);
  }, []);

  return (
    <>
      {!viewPrivacyPolicy && (
        <div className="">
          <StaticBanner BannerImg={BannerImg} en_US={'Our Policy'} />
          <section className="py-5">
            <div className="container flex justify-center">
              <div className="flex flex-col items-center p-10 sm:p-0">
                <h5 className="text-customgreen text-xl sm:text-lg text-center font-bold pb-3">
                  {t('View Our Privacy Policy')}
                </h5>
                <div className="w-30 h-30 text-center cursor-pointer py-4">
                  <svg
                    onClick={() => setViewPrivacyPolicy(true)}
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 18 18"
                  >
                    <g fill="#fa0e0a" stroke="none">
                      <path d="M12.819 14.427c.064.267.077.679-.021.948-.128.351-.381.528-.754.528h-.637v-2.12h.496c.474 0 .803.173.916.644zm3.091-8.65c2.047-.479 4.805.279 6.09 1.179-1.494-1.997-5.23-5.708-7.432-6.882 1.157 1.168 1.563 4.235 1.342 5.703zm-7.457 7.955h-.546v.943h.546c.235 0 .467-.027.576-.227.067-.123.067-.366 0-.489-.109-.198-.341-.227-.576-.227zm13.547-2.732v13h-20v-24h8.409c4.858 0 3.334 8 3.334 8 3.011-.745 8.257-.42 8.257 3zm-12.108 2.761c-.16-.484-.606-.761-1.224-.761h-1.668v3.686h.907v-1.277h.761c.619 0 1.064-.277 1.224-.763.094-.292.094-.597 0-.885zm3.407-.303c-.297-.299-.711-.458-1.199-.458h-1.599v3.686h1.599c.537 0 .961-.181 1.262-.535.554-.659.586-2.035-.063-2.693zm3.701-.458h-2.628v3.686h.907v-1.472h1.49v-.732h-1.49v-.698h1.721v-.784z" />
                    </g>
                  </svg>
                </div>
              </div>
            </div>
          </section>
        </div>
      )}
      {viewPrivacyPolicy && <Ourpolicy />}
    </>
  );
};

export default OurPolicyPdfView;
